import spinner from '../utils/rbmc.spinner';
import urlUtils from "../utils/rbmc.url-utils";

const giftCard = {
    $giftCardBalanceWrapper: undefined,
    $giftCardBalanceInput:   undefined,
    $giftCardBalanceSubmit:  undefined,
    $giftCardMessageBox:     undefined,
    errorClass:              'giftcard-balance__message--error',
    successClass:            'giftcard-balance__message--success',
    voucherCode:             '',
    cacheSelectors() {
        this.$giftCardBalanceWrapper = $('.giftcard-balance');
        this.$giftCardBalanceInput = this.$giftCardBalanceWrapper.find('#gc-balance-input');
        this.$giftCardBalanceSubmit = this.$giftCardBalanceWrapper.find('#gc-balance-button');
        this.$giftCardMessageBox = this.$giftCardBalanceWrapper.find('.giftcard-balance__message');
    },

    bindEvents() {
        this.$giftCardBalanceInput.on('keyup change', giftCard.onUserInputChange);

        this.$giftCardBalanceSubmit.on('click', () => {
            giftCard.balanceCheck(giftCard.voucherCode)
        });
    },

    onUserInputChange(evt) {

        const $voucherValue = $(evt.currentTarget).val();
        if ($voucherValue.length) {
            giftCard.$giftCardBalanceSubmit.removeClass('disabled')
        } else {
            giftCard.$giftCardBalanceSubmit.addClass('disabled')
            giftCard.removeMessages();
        }
        giftCard.voucherCode = $voucherValue;
    },

    balanceCheck(voucherCode) {
        if (!giftCard.voucherCode.length) {
            return false;
        }
        giftCard.removeMessages();
        spinner.spinnerVisibility(true);
        const request = $.ajax({
            url:         `${urlUtils.getBaseUrl()}giftcard/status`,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({'code': voucherCode})
        });

        request.done((res) => {
            if ('success' in res) {
                giftCard.adjustMessage(false, res.success, res.message)
            } else {
                giftCard.adjustMessage(true, false);
            }
        });

        request.fail((res) => {
            if ('success' in res) {
                giftCard.adjustMessage(false, res.success, res.message)
            } else {
                giftCard.adjustMessage(true, false);
            }
        });

        request.always(() => {
            spinner.spinnerVisibility(false);
        })
    },

    adjustMessage(generalMsg, success = false, message = '') {
        giftCard.$giftCardMessageBox
                .html(!generalMsg ? message : giftCard.$giftCardMessageBox.data('general-error'))
                .addClass(success ? giftCard.successClass : giftCard.errorClass);
    },

    removeMessages() {
        giftCard.$giftCardMessageBox
                .html('')
                .removeClass(giftCard.successClass)
                .removeClass(giftCard.errorClass);
    }
}

$(() => {
    if ($('.page-giftCardBalancePage').length) {
        giftCard.cacheSelectors();
        giftCard.bindEvents();
    }
});

export default giftCard;
